export const emphasis = '#38e0d2';
export const darkerEmphasis = '#34cfc7';
export const increase = '#53c41b';
export const decrease = '#f3212e';
export const same = '#ddd';
export const orange = '#ebac38';
export const redOrange = '#cc6b33';
export const brightYellow = '#f5f25d';
export const brightPink = '#f42bff';
